module.exports = __webpack_public_path__ + "static/img/s405.034c683.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s405.png
// module id = 557
// module chunks = 3